import { Fragment, useEffect, useState, useRef } from "react";
import { MdAddAPhoto, MdVideoCall, MdVideoFile } from "react-icons/md";
import LoadingSpinner from "./LoadingSpinner";
import { IoMdCloseCircle } from "react-icons/io";

export default function ImageCarousel({ images, setImages, preview }) {
  const [displayImage, setDisplayImage] = useState(images ? images[0] : false);
  const [carousel, setCarousel] = useState(images || []);
  const [loading, setLoading] = useState(false);

  const addImage = async () => {
    try {
      const fileInput = document.getElementById("image-input");
      fileInput.click();
      setLoading(true);
      await fileInput.addEventListener("change", (e) => {
        const files = e.target.files;
        if (!files) return;
        setImages([...images, ...files]);
        const fileArray = Array.from(files);
        const fileURLs = fileArray.map((file) => URL.createObjectURL(file));
        setCarousel([...carousel, ...fileURLs]);
      });
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  const addVideo = async () => {
    try {
      const fileInput = document.getElementById("video-input");
      fileInput.click();
      setLoading(true);
      await fileInput.addEventListener("change", (e) => {
        const files = e.target.files;
        if (!files) return;
        setImages([...images, ...files]);
        const fileArray = Array.from(files);
        const fileURLs = fileArray.map((file) => URL.createObjectURL(file));
        setCarousel([...carousel, ...fileURLs]);
      });
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  const removeImage = (idx) => {
    if (images.length > 1) {
      setImages(images.filter((_, index) => index !== idx));
      setCarousel(carousel.filter((_, index) => index !== idx));
    } else if (images.length === 1) {
      setImages([]);
      setCarousel([]);
      setDisplayImage(false);
    }
  };

  if (loading) return <LoadingSpinner />;

  return (
    <div className="grid gap-4 lg:grid-cols-2">
      {preview && (
        <div>
          {displayImage ? (
            <img
              src={displayImage}
              className="max-h-[30vh] rounded-xl object-contain cursor-zoom-in"
              onClick={() => window.open(displayImage, "_blank")}
            />
          ) : (
            <div className="md:w-[500px] w-full h-[200px] bg-gray-300 dark:bg-stone-700 rounded-xl"></div>
          )}
        </div>
      )}
      <div className="grid content-start grid-cols-5 gap-2">
        {carousel.map((image, idx) => (
          <div key={idx} className="relative group">
            {images[idx]?.type?.includes("video") || image.includes("video") ? (
              <div
                onClick={() => window.open(image, "blank")}
                className="flex items-center justify-center w-[80px] h-[80px] clickable bg-stone-100 rounded-xl"
              >
                <MdVideoFile className="w-10 h-10 mx-4 text-yellow-600" />
              </div>
            ) : (
              <img
                key={idx}
                onClick={() => setDisplayImage(image)}
                className="object-cover cursor-pointer h-[80px] w-[80px] rounded-xl"
                src={image}
              />
            )}
            <IoMdCloseCircle
              className="absolute hidden text-2xl text-red-500 cursor-pointer group-hover:block -right-2 -top-2"
              onClick={() => removeImage(idx)}
            />
          </div>
        ))}
        {setImages && (
          <Fragment>
            <div
              onClick={addImage}
              className="flex items-center justify-center w-[80px] h-[80px] clickable bg-stone-700 rounded-xl"
            >
              <MdAddAPhoto className="w-8 h-8 mx-4 text-white" />
            </div>
            <div
              onClick={addVideo}
              className="flex items-center justify-center w-[80px] h-[80px] clickable bg-stone-700 rounded-xl"
            >
              <MdVideoCall className="w-8 h-8 mx-4 text-white" />
            </div>
          </Fragment>
        )}
      </div>
      <input
        className="hidden"
        id="image-input"
        type="file"
        accept="image/*"
        multiple={true}
      />

      <input
        className="hidden"
        id="video-input"
        type="file"
        accept="video/*"
        multiple={true}
      />
    </div>
  );
}
